import { render } from "./RegisterModal.vue?vue&type=template&id=372ccf82&scoped=true&ts=true"
import script from "./RegisterModal.vue?vue&type=script&lang=ts"
export * from "./RegisterModal.vue?vue&type=script&lang=ts"

import "./RegisterModal.vue?vue&type=style&index=0&id=372ccf82&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372ccf82"]])

export default __exports__